import script from "./SkuHistoryCompositesList.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuHistoryCompositesList.vue?vue&type=script&setup=true&lang=js"

import "./SkuHistoryCompositesList.vue?vue&type=style&index=0&id=24ff372a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ff372a"]])

export default __exports__